var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("CoreUI © 2019 creativeLabs.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }